import React from "react";
import IdCard from "./IdCard";
import dayjs from "dayjs";
import "dayjs/locale/ko";
const HealthCard = ({ myInfoList, myInfo, handleToggle }) => {
  dayjs.locale("ko");
  const datas = [
    {
      id: 1,
      title: "Age / Gender",
      data: myInfo?.userTypeCode
        ? myInfo.userTypeCode === "UT101"
          ? `${myInfoList?.patientInfo?.age} / ${myInfoList?.patientInfo?.gender}`
          : `${myInfoList?.age} / ${myInfoList?.gender}`
        : "- / -",
    },
    {
      id: 2,
      title: "Height / Weight",
      data: myInfo?.userTypeCode
        ? `${myInfoList?.height}cm / ${myInfoList?.weight}kg`
        : "- / -",
    },
    {
      id: 3,
      title: "Cancer Type & Stage",
      data: `${myInfoList?.cancerType || "-"} ${
        myInfoList?.cancerStaging || ""
      }`,
    },
    { id: 4, title: "Surgery Status", data: myInfoList?.operationYN || "-" },
    { id: 5, title: "Surgery Timing", data: myInfoList?.operationAfter || "-" },
    {
      id: 6,
      title: "Treatment Type",
      data: myInfoList?.anticancerTreatmentType || "-",
    },
    {
      id: 7,
      title: "Treatment Stage",
      data: myInfoList?.anticancerTreatmentYN || "-",
    },
  ];
  return (
    <div className=" rounded-[20px] bg-white">
      <ul className="flex flex-col gap-3 p-5">
        <li id="title">
          <span className="text-base font-semibold text-black">Health Card</span>
        </li>
        {datas.map((data) => (
          <li key={data.id} className="flex justify-between gap-3 items-baseline">
            <span className="shrink-0 text-sm font-medium text-gray_160">
              {data.title}
            </span>
            <span className="text-right text-sm font-semibold text-green_100">
              {data.data}
              {data.unit}
            </span>
          </li>
        ))}
      </ul>
      {myInfo?.userTypeCode === "UT101" ? (
        <div className="flex flex-col border-t border-dashed border-gray_80 ">
          <IdCard myInfo={myInfo} patientCard={true} />
          <span className="mb-5 text-center text-xs font-semibold text-gray_160">
            Issued on{" "}
            {dayjs(myInfoList?.patientInfo?.registDay).format("YYYY-MM-DD")}
          </span>
          {/* <div onClick={() => handleToggle()}>
            <img
              alt={"arrowRight"}
              src="/images/mobile/icon/arrow_right.svg"
              className="mx-auto mb-4 h-6 w-6 rotate-[270deg] transform"
            />
          </div> */}
        </div>
      ) : // <div className="flex flex-col" onClick={() => handleToggle()}>
      //   <img
      //     alt={"arrowRight"}
      //     src="/images/mobile/icon/arrow_right.svg"
      //     className="mx-auto mb-4 h-6 w-6 rotate-[270deg] transform"
      //   />
      // </div>
      null}
    </div>
  );
};

export default HealthCard;
